import api from '../api';

export const fetchTemplates = (data) => api.post('/core/functions/fetchTemplates', data);

export const createRequest = (data) => api.post('/core/functions/createUpdateRequest', data);

export const publishRequest = (requestId) => api.post('/core/functions/updatePublishStatusRequest', { requestId });

export const shareRequest = (data) => api.post('/core/functions/shareRequest', data);
